import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

/**
 * Reusable ReverseTimer Component
 *
 * @param {number} duration - total seconds (e.g., 600 for 10 minutes)
 * @param {function} onExpire - callback when timer reaches 0
 * @param {function} onResend - async callback when resend is clicked — must return true/false
 * @param {function} onActiveChange - callback when timer becomes active/inactive
 */
const ReverseTimer = ({ duration, onExpire, onResend, onActiveChange }) => {
  const [timeLeft, setTimeLeft] = useState(duration);
  const [isActive, setIsActive] = useState(true);
  const timerRef = useRef(null);

  // Notify parent of active status
  useEffect(() => {
    onActiveChange?.(isActive && timeLeft > 0);
  }, [isActive, timeLeft, onActiveChange]);

  // Countdown logic
  useEffect(() => {
    if (isActive && timeLeft > 0) {
      timerRef.current = setInterval(
        () => setTimeLeft((prev) => prev - 1),
        1000
      );
    }

    if (timeLeft === 0) {
      clearInterval(timerRef.current);
      onExpire?.();
    }

    return () => clearInterval(timerRef.current);
  }, [isActive, timeLeft]);

  // Resend Handler
  const handleResendClick = async () => {
    setIsActive(false);
    clearInterval(timerRef.current);

    try {
      const success = await onResend?.();
      if (success) {
        setTimeLeft(duration);
        setIsActive(true);
      }
    } catch (err) {
      console.error("Resend failed:", err);
    }
  };

  const formatTime = (sec) => {
    const m = String(Math.floor(sec / 60)).padStart(2, "0");
    const s = String(sec % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      {timeLeft > 0 ? (
        <span style={{ fontWeight: 500 }}>
          Resend OTP in {formatTime(timeLeft)}
        </span>
      ) : (
        <a
          onClick={handleResendClick}
          style={{ color: "#1890ff", cursor: "pointer", fontWeight: 500 }}
        >
          Resend OTP
        </a>
      )}
    </div>
  );
};

ReverseTimer.propTypes = {
  duration: PropTypes.number.isRequired,
  onExpire: PropTypes.func,
  onResend: PropTypes.func,
  onActiveChange: PropTypes.func,
};

export default ReverseTimer;
